import Router from '../utils/router.js';
import Loader from './modules/loader.js';
import SearchView from './views/search-view.js';
import FormView from './views/form-view.js';
import ConfirmView from './views/confirm-view.js';

export default class BATD {
    constructor(el) {
        this.router = new Router();
        this.el = el;
        this.loader = new Loader(this, this.router);
        this.search = new SearchView(this, this.router);
        this.form = new FormView(this, this.router);
        this.confirm = new ConfirmView(this, this.router);

        this.setup();
    }

    setup() {
        this.router
            .add('search', () => {
                this.loader.hide();
                this.search.show();
                this.form.hide();
                this.confirm.hide();
            })
            .add('form', () => {
                this.loader.hide();
                this.search.hide();
                this.form.show();
                this.confirm.hide();
            })
            .add('confirm', () => {
                this.loader.hide();
                this.search.hide();
                this.form.hide();
                this.confirm.show();
            })
            .else(() => {
                this.router.update('search');
            })
            .match();
    }    
}
